export enum CommunityMatchActivityColumn {
  NAME,
  DATE_CREATED,
  ACTIVITY_RESULT,
  NEXT_STEP,
  NOTES,
  CREATED_BY,
  DUE_DATE,
  RATING,
}
